import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import './index.css';

import { 
  Card, 
  Statistic, 
  Progress, 
  Row,
  Col,
  Typography,
  Button
} from 'antd';
import { 
  ArrowUpOutlined,
  ArrowDownOutlined
} from '@ant-design/icons';

const { Title, Text } = Typography;

function Dash() {
  // 假数据 - 后续替换为 API
  const mockData = {
    // 顶部统计卡片
    topStats: [
      {
        title: '总货物数量',
        value: 1248,
        trend: 5.2,
        trendType: 'up',
        color: '#1f63fb'
      },
      {
        title: '运输中',
        value: 356,
        subtitle: '占总货物 28.6%',
        color: '#722ed1'
      },
      {
        title: '已到港',
        value: 235,
        trend: 8.7,
        trendType: 'up',
        color: '#52c41a'
      },
      {
        title: '异常货物',
        value: 156,
        trend: 2.3,
        trendType: 'down',
        color: '#de1c1c'
      }
    ],
    
    // 运输进度阶段
    transportStages: [
      { name: '订舱确认', date: '2024-06-01', status: 'completed', color: '#5ec26a' },
      { name: '集装完成', date: '2024-06-05', status: 'completed', color: '#5ec26a' },
      { name: '已装船', date: '2024-06-10', status: 'completed', color: '#5ec26a' },
      { name: '运输中', date: '2024-06-15', status: 'completed', color: '#5ec26a' },
      { name: '已到港', date: '2024-06-28', status: 'current', color: '#ff4d4f' },
      { name: '海关查验', date: '预计: 2024-07-02', status: 'pending', color: '#d9d9d9' },
      { name: '海关放行', date: '预计: 2024-07-03', status: 'pending', color: '#d9d9d9' },
      { name: '船司放行', date: '预计: 2024-07-04', status: 'pending', color: '#d9d9d9' },
      { name: '码头卸货', date: '预计: 2024-07-05', status: 'pending', color: '#d9d9d9' },
      { name: '已完成', date: '预计: 2024-07-10', status: 'pending', color: '#d9d9d9' }
    ],
    
    // 处理阶段进度
    processingStages: [
      { name: '订舱确认', percent: 0, color: '#e2e8f0' },
      { name: '预配', percent: 0, color: '#e2e8f0' },
      { name: '集装完成', percent: 25, color: '#dcfce7' },
      { name: '配载', percent: 40, color: '#fffbeb' },
      { name: '提单确认', percent: 45, color: '#fffbeb' },
      { name: '海关', percent: 30, color: '#fffbeb' },
      { name: '放行', percent: 25, color: '#dcfce7' },
      { name: '装船', percent: 30, color: '#fffbeb' },
      { name: '运输中', percent: 28, color: '#dcfce7', alert: true },
      { name: '提货通知', percent: 25, color: '#dcfce7' },
      { name: '到港', percent: 23, color: '#dcfce7' },
      { name: '提货', percent: 22, color: '#dcfce7', alert: true },
      { name: '已完成', percent: 20, color: '#dcfce7' },
      { name: '配送', percent: 19, color: '#dcfce7' }
    ],
    
    // 底部三个指标
    bottomMetrics: [
      { name: '待海关放行', value: 142, total: 500, color: '#ff7a45' },
      { name: '待船司放行', value: 128, total: 500, color: '#13c2c2' },
      { name: '待客户提货', value: 134, total: 500, color: '#52c41a' }
    ],
    
    // 异常状态监控
    exceptionStatus: [
      { name: '海关查验', value: 48, description: '单证不全、商品归类问题', avgResolveTime: '3-5 天', icon: '海', color: '#fa8c16' },
      { name: '延误', value: 36, description: '天气原因、港口拥堵', avgResolveTime: '2-7 天', icon: '延', color: '#faad14' },
      { name: '单证问题', value: 72, description: '提单错误、原产地证缺失', avgResolveTime: '1-3 天', icon: '单', color: '#1f63fb' }
    ],
    
    // 最近操作记录
    recentOperations: [
      { type: '新增', title: '新增货物 #1001', description: '由 张三 添加了新的货物记录 MBL: MBL20240001', time: '2024-06-28 09:15', icon: 'new' },
      { type: '更新', title: '货物状态更新', description: '由 李四 将货物 #1002 的状态从 运输中 更新为 已到港', time: '2024-06-28 08:40', icon: 'update' },
      { type: '标记', title: '标记异常', description: '由 王五 将货物 #1003 标记为 海关查验 异常', time: '2024-06-28 07:22', icon: 'flag' }
    ]
  };

  // 月度出货量趋势图
  const monthTrendOption = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      top: '10%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        name: '月度',
        type: 'line',
        smooth: true,
        data: [120, 200, 150, 180, 220, 190, 210, 250, 230, 260, 240, 280],
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: 'rgba(31, 99, 251, 0.8)'
            }, {
              offset: 1, color: 'rgba(31, 99, 251, 0.1)'
            }]
          }
        },
        itemStyle: {
          color: '#1f63fb'
        }
      }
    ]
  };

  // 货物状态分布饼图
  const statusDistributionOption = {
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
      orient: 'vertical',
      left: 'left',
      bottom: '10%',
      data: ['运输中', '已到港', '已完成', '异常']
    },
    series: [
      {
        name: '货物状态',
        type: 'pie',
        radius: ['40%', '70%'],
        center: ['60%', '50%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 10,
          borderColor: '#fff',
          borderWidth: 2
        },
        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 20,
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: [
          { value: 356, name: '运输中', itemStyle: { color: '#1f63fb' } },
          { value: 235, name: '已到港', itemStyle: { color: '#13c2c2' } },
          { value: 490, name: '已完成', itemStyle: { color: '#52c41a' } },
          { value: 156, name: '异常', itemStyle: { color: '#ff4d4f' } }
        ]
      }
    ]
  };

  return (
    <div className="dash">
      <div className="dash-header">
        <Title level={3} style={{ margin: 0 }}>物流仪表盘</Title>
        <Text className="update-time">更新于 2024-06-28 10:30</Text>
      </div>

      <div className="dash-content">
        {/* 顶部统计卡片 */}
        <div className="top-stats">
          {mockData.topStats.map((stat, index) => (
            <div key={index} className="stat-card" style={{ borderLeft: `0px solid ${stat.color}` }}>
              <div className="stat-header">{stat.title}</div>
              <div className="stat-value" style={{ color: stat.color }}>{stat.value}</div>
              {stat.trend && (
                <div className={`stat-trend ${stat.trendType}`}>
                  {stat.trendType === 'up' ? (
                    <>
                      <ArrowUpOutlined /> 较昨日增长 {stat.trend}%
                    </>
                  ) : (
                    <>
                      <ArrowDownOutlined /> 较昨日增长 {stat.trend}%
                    </>
                  )}
                </div>
              )}
              {stat.subtitle && (
                <div className="stat-subtitle">{stat.subtitle}</div>
              )}
            </div>
          ))}
        </div>

        {/* 货物运输进度 */}
        <div className="card transport-progress">
          <div className="card-header">
            <h3 className="card-title">货物运输进度</h3>
            <span className="card-update-time">更新于 2024-06-28 10:30</span>
          </div>
          
          <div className="progress-timeline">
            {mockData.transportStages.map((stage, index) => (
              <div 
                key={index} 
                className="timeline-segment" 
                style={{ 
                  backgroundColor: stage.status === 'completed' ? '#5ec26a' : 
                                  stage.status === 'current' ? '#ff4d4f' : '#d9d9d9',
                  flex: 1
                }}
              />
            ))}
          </div>
          
          <div className="progress-stages">
            {mockData.transportStages.map((stage, index) => (
              <div key={index} className="stage-item">
                <div 
                  className={`stage-dot ${stage.status}`}
                  style={{ backgroundColor: stage.color }}
                />
                <div className="stage-date">{stage.date}</div>
                <div className={`stage-status ${stage.status}`}>
                  {stage.status === 'completed' ? '已完成' : 
                   stage.status === 'current' ? '进行中' : '未开始'}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 货物处理阶段 */}
        <div className="card processing-stages">
          <div className="card-header">
            <h3 className="card-title">货物处理阶段</h3>
            <button className="view-all-btn">查看详情</button>
          </div>
          
          <div className="stages-header">
            {mockData.processingStages.map((stage, index) => (
              <div key={index} className="stage-header-item">{stage.name}</div>
            ))}
          </div>
          
          <div className="stages-bar">
            {mockData.processingStages.map((stage, index) => (
              <div 
                key={index} 
                className={`stage-bar-item ${stage.alert ? 'alert' : ''}`}
                style={{ backgroundColor: stage.color }}
              >
                {stage.percent}%
              </div>
            ))}
          </div>
        </div>

        {/* 底部三个指标 */}
        <div className="bottom-metrics">
          {mockData.bottomMetrics.map((metric, index) => (
            <div key={index} className="metric-card">
              <div className="metric-title">{metric.name}</div>
              <div className="metric-value" style={{ color: metric.color }}>{metric.value}</div>
              <div className="metric-progress">
                <div 
                  className="metric-progress-bar" 
                  style={{ 
                    width: `${(metric.value / metric.total * 100).toFixed(0)}%`,
                    backgroundColor: metric.color
                  }}
                />
              </div>
            </div>
          ))}
        </div>

        {/* 图表区域 */}
        <div className="charts-container">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">月度出货量趋势</h3>
              <div className="chart-controls">
                <button className="chart-control-btn active">本月</button>
                <button className="chart-control-btn">季度</button>
                <button className="chart-control-btn">年度</button>
              </div>
            </div>
            <ReactECharts option={monthTrendOption} style={{ height: 300 }} />
          </div>
          
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">货物状态分布</h3>
              <button className="view-all-btn">查看详情</button>
            </div>
            <ReactECharts option={statusDistributionOption} style={{ height: 300 }} />
          </div>
        </div>

        {/* 异常状态监控 */}
        <div className="card">
          <div className="card-header">
            <h3 className="card-title">异常状态监控</h3>
            <button className="view-all-btn">查看全部</button>
          </div>
          
          <div className="exceptions-container">
            {mockData.exceptionStatus.map((exception, index) => (
              <div key={index} className="exception-card">
                <div className="exception-icon" style={{ backgroundColor: exception.color }}>
                  {exception.icon}
                </div>
                <div className="exception-details">
                  <div className="exception-title">{exception.name}</div>
                  <div className="exception-description">{exception.description}</div>
                  <div className="exception-time">平均排解时间: {exception.avgResolveTime}</div>
                </div>
                <div className="exception-action">
                  <button className="exception-action-btn">{exception.value} 处理</button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 最近操作记录 */}
        <div className="operations-container">
          <div className="operations-header">
            <h3>最近操作记录</h3>
            <div className="operations-actions">
              <button className="filter-btn">筛选</button>
              <button className="view-all-btn">查看全部</button>
            </div>
          </div>
          
          {mockData.recentOperations.map((operation, index) => (
            <div key={index} className="operation-item">
              <div 
                className="operation-type"
                style={{ 
                  backgroundColor: operation.type === '新增' ? '#e6f7ff' : 
                                 operation.type === '更新' ? '#f6ffed' : '#fff7e6',
                  color: operation.type === '新增' ? '#1f63fb' : 
                        operation.type === '更新' ? '#52c41a' : '#faad14'
                }}
              >
                {operation.type.charAt(0)}
              </div>
              <div className="operation-content">
                <div className="operation-title">{operation.title}</div>
                <div className="operation-description">{operation.description}</div>
              </div>
              <div className="operation-time">{operation.time}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Dash;